const DocumentsTypes = {
    Regulations: 'regulations',
} as const;

export default DocumentsTypes;
